module.exports = new __parcel__URL__("logo.42a13c65.png").toString();